import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoggingMessageService } from './logging-message.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { SubscriptionChangeService } from './subscription-change.service';

@Injectable({
  providedIn: 'root'
})
export class DemographicContentService {
  private _BASE_URL = environment.BusinessApi;
  private currentDemographicData = new Subject<any>();
  public currentDemographicData$ = this.currentDemographicData.asObservable();

  constructor(private http: HttpClient, private logger: LoggingMessageService, private sessionService: SessionStorageService, private subscriptionService: SubscriptionChangeService) { }

  public setSource(src: string) {
    this.currentDemographicData.next(src);
  }

   public getDemographicContent(hospitalName: string): Observable<any> {
    if (environment.UseServerForHospitalDemographicContent) {
      return this.getBusinessDemographicData(hospitalName);
    } else {
      return;
    }
  }

  private getBusinessDemographicData(hospitalName: string): Observable<any> {
    let uri = `${this._BASE_URL}FacilityDemographis?hospId=${45}`; // temp data
    const media = environment.GetDemographicContentMedia;
    return this.http
      .get<any>(uri,
        {
          headers: { Accept: media },
          observe: 'response'
        }
      )
      .pipe(
        map(response => {
          let result: any;
          if (response instanceof HttpResponse) {
            if (response.status === 200) {
              result = response.body;
            }
          }
          return result;
        }),
        catchError(error => {
          return this.handleError(`getBusinessDemographicData failed`, error, hospitalName);
        }),
        take(1)
      );
  }

  private handleError(operation: string, error: any, hospName: string) {
    const result = this.logger.error('demographic-content.service', 'handleError', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `Operation:${operation} hospName:${hospName}`, error.message);
    return of(result);
  }

}
